import * as React from 'react';
import { Search } from 'ui';
import { CodetableTranslation } from '../../constants';

import styles from './codetable-search.scss';

interface CodetableSearchProps {
  query: string;
  translation: CodetableTranslation;
  updateQuery: (value: string) => void;
  readOnly?: boolean;
  children?: React.ReactNode;
}

export const CodetableSearch = (props: CodetableSearchProps) => {

  const { query, updateQuery, translation, readOnly, children } = props;

  const onSearch = () => updateQuery(query);

  return <div className={`row ${styles.searchSection}`}>
    <div className="col-lg-9 col-md-12">
      <Search
        className={`${styles.searchField} input-wrapper`}
        componentId={'codetable-search'}
        readOnly={readOnly}
        onChange={updateQuery}
        value={query}
        minLength={1}
        maxLength={255}
        onSearch={onSearch}
        placeholder={translation.search}
        focus={true} />
    </div>
    <div className="col-lg-3 col-md-12">
      <div className={styles.searchToolbar}>
        {children}
      </div>
    </div>
  </div>;
};
